import $ from 'jquery';

//TODO guck mal was das alles ist … und was raus kann

//// MAGNIFIC-POPUP ////

// http://stackoverflow.com/a/26203033/1178688  // more options
$.magnificPopup.instance.next = function () {
  if ($.magnificPopup.instance.index < $.magnificPopup.instance.items.length - 1) {
    $.magnificPopup.proto.next.call(this);
  }
};
$.magnificPopup.instance.prev = function () {
  if ($.magnificPopup.instance.index > 0) {
    $.magnificPopup.proto.prev.call(this);
  }
};

$.magnificPopup.instance.toggleArrows = function () {
  if ($.magnificPopup.instance.index < $.magnificPopup.instance.items.length - 1) {
    // $(".mfp-arrow-right").show();
    // $(".mfp-arrow-right").toggleClass("arrow-show arrow-hide");
    $(".mfp-arrow-right").removeClass("arrow-hide");
  }
  if ($.magnificPopup.instance.index == $.magnificPopup.instance.items.length - 1) {
    // $(".mfp-arrow-right").hide();
    // $(".mfp-arrow-right").toggleClass("arrow-show arrow-hide");
    $(".mfp-arrow-right").addClass("arrow-hide");
  }

  if ($.magnificPopup.instance.index > 0) {
    // $(".mfp-arrow-left").show();
    // $(".mfp-arrow-left").toggleClass("arrow-show arrow-hide");
    $(".mfp-arrow-left").removeClass("arrow-hide");
  }
  if ($.magnificPopup.instance.index == 0) {
    // $(".mfp-arrow-left").hide();
    // $(".mfp-arrow-left").toggleClass("arrow-show arrow-hide");
    $(".mfp-arrow-left").addClass("arrow-hide");
  }
};

$.magnificPopup.instance.updateItemHTML = function () {
  $.magnificPopup.instance.toggleArrows();
  $.magnificPopup.proto.updateItemHTML.call(this);
};


// IMAGE-BOX //
$('figure.box .gallery_open').magnificPopup({
  type: 'image',
  gallery: {
    enabled: true,
    arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir% arrow-init"></button>',
    tPrev: 'zurück (linke Pfeiltaste)',
    tNext: 'weiter (rechte Pfeiltaste)',
    tCounter: '%curr% von %total%'
  },
  image: {
    markup: '<div class="mfp-figure">' +
      '<div class="mfp-close"></div>' +
      '<div class="mfp-img"></div>' +
      '<div class="mfp-bottom-bar galery_3n">' +
      '<div class="mfp-title galery_3n"></div>' +
      '<div class="mfp-counter"></div>' +
      '</div>' +
      '</div>',
    titleSrc: function (item) {
      return item.el.attr('data-title2') + '<small>' + item.el.attr('data-copyright') + '</small>';
    }
  },
  callbacks: {
    open: function () {
      this.toggleArrows.call(this);
    }
  }
});

// IMAGE-BOX //
$('.si_box .gallery_open').magnificPopup({
  type: 'image',
  gallery: {
    enabled: true,
    arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir% arrow-init"></button>',
    tPrev: 'zurück (linke Pfeiltaste)',
    tNext: 'weiter (rechte Pfeiltaste)',
    tCounter: '%curr% von %total%'
  },
  image: {
    markup: '<div class="mfp-figure">' +
      '<div class="mfp-close"></div>' +
      '<div class="mfp-img"></div>' +
      '<div class="mfp-bottom-bar galery_3n">' +
      '<div class="mfp-title galery_3n"></div>' +
      '<div class="mfp-counter"></div>' +
      '</div>' +
      '</div>',
    titleSrc: function (item) {
      return item.el.attr('data-title2') + '<small>' + item.el.attr('data-copyright') + '</small>';
    }
  },
  callbacks: {
    open: function () {
      this.toggleArrows.call(this);
    }
  }
});


// // MULTI GRID //
// $('.multi_grid a.mg__popup_element').magnificPopup({
//   type: 'image',
//   gallery: {
//       enabled: true,
//       arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir% arrow-init"></button>',
//       tPrev: 'zurück (linke Pfeiltaste)',
//       tNext: 'weiter (rechte Pfeiltaste)',
//       tCounter: '%curr% von %total%'
//   },
//   image: {
//       markup: '<div class="mfp-figure">' +
//           '<div class="mfp-close"></div>' +
//           '<div class="mfp-img"></div>' +
//           '<div class="mfp-bottom-bar galery_3n">' +
//           '<div class="mfp-title galery_3n"></div>' +
//           '<div class="mfp-counter"></div>' +
//           '</div>' +
//           '</div>',
//       titleSrc: function(item) {
//           return item.el.attr('data-title2') + '<small>' + item.el.attr('data-copyright') + '</small>';
//       }
//   },
//   callbacks: {
//       open: function() {
//           this.toggleArrows.call(this);
//       }
//   }
// });




// MULTI GRID //
function multiGrid_MagnificPopup(_selector, _galleryEnabled, _preload) {
  var loop = ($(_selector).attr("data-loop") === 'true');
  $(_selector).magnificPopup({
    delegate: 'a.mg__popup_element',
    type: 'image',
    gallery: {
      enabled: _galleryEnabled,
      preload: _preload,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir% arrow-init loop_' + loop + '"></button>',
      tPrev: 'zurück (linke Pfeiltaste)',
      tNext: 'weiter (rechte Pfeiltaste)',
      tCounter: '%curr% von %total%'
    },
    image: {
      markup: '<div class="mfp-figure">' +
        '<div class="mfp-close"></div>' +
        '<div class="mfp-img"></div>' +
        '<div class="mfp-bottom-bar galery_3n">' +
        '<div class="mfp-title galery_3n"></div>' +
        '<div class="mfp-counter"></div>' +
        '</div>' +
        '</div>',
      titleSrc: function (item) {
        return item.el.attr('data-title2') + '<small>' + item.el.attr('data-copyright') + '</small>';
      }
    },
    callbacks: {
      open: function () {

        if (!loop) {
          this.toggleArrows.call(this);
        }

        var mfp = $.magnificPopup.instance;
        var proto = $.magnificPopup.proto;

        // extend function that moves to next item
        mfp.next = function () {
          // if index is not last, call parent method
          if (mfp.index < mfp.items.length - 1) {
            proto.next.call(mfp);

          } else {
            if (loop) {
              mfp.goTo(0);
            }
          }
        };

        // same with prev method
        mfp.prev = function () {
          if (mfp.index > 0) {
            proto.prev.call(mfp);
          }
          else {
            if (loop) {
              mfp.goTo(mfp.items.length - 1);
            }
          }
        };

      }
    }
  });
}

function load_multiGrid() {
  multiGrid_MagnificPopup('.multi_grid:is([data-gallery="multi_gallery"])', true, [1, 3]);

  multiGrid_MagnificPopup('.multi_grid:is([data-gallery="single_image"])', false);

  const single_galleries = document.querySelectorAll('.multi_grid[data-gallery="single_gallery"]');
  for (let i = 0; i < single_galleries.length; i++) {
    console.log("1: " + single_galleries[i]);
    multiGrid_MagnificPopup(single_galleries[i], true, [1, 3]);
  }
}
load_multiGrid();


// auch im angeladenden Info-Fenster von GoogleMaps laden 
var map_exists = document.querySelector('#map') !== null;
if (map_exists) {
  document.querySelector("#map").addEventListener("click", () => {
    load_multiGrid();
  });
}




// KONTAKT-POPUP //
$('.popup_kontakt').magnificPopup({
  type: 'inline',
  closeOnContentClick: false,
  closeOnBgClick: false,
  closeBtnInside: true,
  showCloseBtn: true,
  autoFocusLast: false
});


// MAP KACHEL
document.querySelectorAll("a.map_db_item").forEach(function (element) {
  element.addEventListener("click", function () {
    let dataId = this.dataset.id;

    // Rufen Sie hier die Magnific Popup-Funktion auf, nachdem der Klick ausgelöst wurde
    openMagnificPopup(dataId);
  });
});

function openMagnificPopup(dataId) {
  const popupOptions = {
    items: {
      src: '#id' + dataId,
      type: 'inline',
      closeOnContentClick: false,
      closeOnBgClick: false,
      closeBtnInside: true,
      showCloseBtn: true,
      autoFocusLast: false
    }
  };

  // Öffnen Sie das Popup programmgesteuert
  $.magnificPopup.open(popupOptions);
  console.log("2: HIER");
  load_multiGrid();
}












//// show popup double-opt-in
// if (document.location.search.indexOf('newsletter=') >= 0) {
//     jQuery.magnificPopup.open({
//       items: {src: '#nl_popup_double-opt-in'},
//       type: 'inline',
//       closeOnContentClick: false,
//       closeOnBgClick: false,
//       closeBtnInside: true,
//       showCloseBtn: false,
//       autoFocusLast: false
//     }, 0);
// }

//// GET URL PARAMETER ////
// https://www.sitepoint.com/get-url-parameters-with-javascript/
function getAllUrlParams(url) {

  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // in case params look like: list[]=thing1&list[]=thing2
      var paramNum = undefined;
      var paramName = a[0].replace(/\[\d*\]/, function (v) {
        paramNum = v.slice(1, -1);
        return '';
      });

      // set parameter value (use 'true' if empty)
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      paramValue = paramValue.toLowerCase();

      // if parameter name already exists
      if (obj[paramName]) {
        // convert value to array (if still string)
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]];
        }
        // if no array index number specified...
        if (typeof paramNum === 'undefined') {
          // put the value on the end of the array
          obj[paramName].push(paramValue);
        }
        // if array index number specified...
        else {
          // put the value at that index number
          obj[paramName][paramNum] = paramValue;
        }
      }
      // if param name doesn't exist yet, set it
      else {
        obj[paramName] = paramValue;
      }
    }
  }

  return obj;
}

if (getAllUrlParams().email) {
  var original = getAllUrlParams().email;
  var decoded = decodeURIComponent(original);
  $("#nl_mail").append(decoded);
}

function hasClass(element, cls) {
  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}




if (getAllUrlParams().newsletter) {
  if (hasClass(document.getElementsByTagName("BODY")[0], 'id-661' || 'id-238') != true) {
    $.magnificPopup.open({
      items: {
        src: '#nl_popup_double-opt-in'
      },
      type: 'inline',
      closeOnContentClick: false,
      closeOnBgClick: false,
      closeBtnInside: true,
      showCloseBtn: false,
      autoFocusLast: false
    }, 0);
  }
}

// function closePopup() {
//   $.magnificPopup.close();
// }

// TODO onClick von 3 Buttons nehmen
// für Holzbau ausgeschaltet
// document.querySelector("#nl_popup .mfp-close_3n").addEventListener('click', ()=>{
//   $.magnificPopup.close();
// });

//// EVENT-ANMELDUNG ////

// if (getAllUrlParams().voranmeldung) {
//   if (hasClass(document.getElementsByTagName("BODY")[0], 'id-661' || 'id-238') != true) {
//     $.magnificPopup.open({
//       items: {
//         src: '#event_anmeldung_doubleoptin'
//       },
//       type: 'inline',
//       closeOnContentClick: false,
//       closeOnBgClick: false,
//       closeBtnInside: true,
//       showCloseBtn: false,
//       autoFocusLast: false
//     }, 0);
//   }
// }

// if (getAllUrlParams().angemeldet) {
//   if (hasClass(document.getElementsByTagName("BODY")[0], 'id-661' || 'id-238') != true) {
//     $.magnificPopup.open({
//       items: {
//         src: '#event_angemeldet'
//       },
//       type: 'inline',
//       closeOnContentClick: false,
//       closeOnBgClick: false,
//       closeBtnInside: true,
//       showCloseBtn: false,
//       autoFocusLast: false
//     }, 0);
//   }
// }



function openPopup_message(_id) {
  $.magnificPopup.open({
    items: {
      src: '#' + _id
    },
    callbacks: {
      close: function () {
        // Will fire when popup is closed
        window.history.pushState({}, document.title, window.location.pathname);
      }
    },
    type: 'inline',
    closeOnContentClick: false,
    closeOnBgClick: false,
    closeBtnInside: true,
    showCloseBtn: false,
    autoFocusLast: false
  }, 0);
}

if (getAllUrlParams().voranmeldung) {
  openPopup_message('event_anmeldung_doubleoptin');
}

if (getAllUrlParams().angemeldet) {
  openPopup_message('event_angemeldet');
}


$("button.mfp-close_3n, button.mfp-close").on("click", function () {
  $.magnificPopup.close();

  // remove the parameter form url zB ?voranmeldung=1
  window.history.pushState({}, document.title, window.location.pathname);
});

